export default "__VITE_ASSET__Dr5nDUEc__"